import React from 'react';
import { Link } from 'react-router-dom';
interface ProjectCardProps {
  title: string;
  description: string;
  imageUrl: string;
  link?: string;
  isExternal?: boolean;
  isWide?: boolean;
}
export function ProjectCard({
  title,
  description,
  imageUrl,
  link,
  isExternal = true,
  isWide = false
}: ProjectCardProps) {
  const layoutClass = isWide ? 'md:col-span-2' : '';
  const content = <>
      <div className="relative aspect-video w-full overflow-hidden bg-[#01052a]" data-id="element-89" data-mp="2gjlsdfs2xl16">
        <img src={imageUrl} alt="" className="h-full w-full object-cover" data-id="element-90" data-mp="2liooubtzuixj" />
      </div>
      <div className="flex min-h-36 flex-col bg-[#01052a] p-6 text-white" data-id="element-91" data-mp="26knvnpki2l73">
        <h3 className="mb-2 text-xl font-semibold" data-id="element-92" data-mp="2bk94qstdw9xj">{title}</h3>
        <p className="text-base leading-6 text-white/80" data-id="element-93" data-mp="2bmvbiq8galep">{description}</p>
      </div>
    </>;
  if (!link) {
    return <article className={`overflow-hidden rounded-lg shadow-xl ${layoutClass}`} data-id="element-94" data-mp="105dhiigo905d">
        {content}
      </article>;
  }
  const interactiveClass = `group block overflow-hidden rounded-lg shadow-xl ring-offset-2 ring-offset-[#496985] transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${layoutClass}`;
  if (isExternal) {
    return <a href={link} target="_blank" rel="noopener noreferrer" className={interactiveClass} aria-label={`${title} (opens in a new tab)`} data-id="element-95" data-mp="5hg7a4ci1mn4">
        {content}
      </a>;
  }
  return <Link to={link} className={interactiveClass} data-id="element-96" data-mp="fekyiil7c8as">
      {content}
    </Link>;
}